import AuthWrapper from '@/_components/layouts/auth-wrapper';

export function Layout({ children }: { children: React.ReactNode }) {
  return <AuthWrapper>{children}</AuthWrapper>;
}
